import { render, staticRenderFns } from "./DateRangeExt.vue?vue&type=template&id=b225b4e4&scoped=true&"
import script from "./DateRangeExt.vue?vue&type=script&lang=js&"
export * from "./DateRangeExt.vue?vue&type=script&lang=js&"
import style0 from "./DateRangeExt.vue?vue&type=style&index=0&id=b225b4e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b225b4e4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b225b4e4')) {
      api.createRecord('b225b4e4', component.options)
    } else {
      api.reload('b225b4e4', component.options)
    }
    module.hot.accept("./DateRangeExt.vue?vue&type=template&id=b225b4e4&scoped=true&", function () {
      api.rerender('b225b4e4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2Uq3IIPcO1KYq/JS/comp/DateRangeExt.vue"
export default component.exports